import Social from 'entity/Social';

export const strToHex = (str: string): number => {
  const color = str.replace('#', '');
  return parseInt('0x' + color);
};

export const getSocialThemeColorHex = (social: Social): number => {
  const themePrimary: number =
    social &&
    social.theme &&
    social.theme.colorPrimary &&
    social.theme.colorPrimary.length > 3 &&
    social.theme.colorPrimary.indexOf('#') === 0
      ? strToHex(social.theme.colorPrimary)
      : 0xffffff;
  const themeSecondary: number =
    social &&
    social.theme &&
    social.theme.colorSecondary &&
    social.theme.colorSecondary.length > 3 &&
    social.theme.colorSecondary.indexOf('#') === 0
      ? strToHex(social.theme.colorSecondary)
      : 0xffffff;
  return themePrimary === 0xffffff ? themeSecondary : themePrimary;
};
